import { Stack, Button, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { ScopeGuard } from '../../../reusable-components/scopes';
import Iconify from '../../../reusable-components/iconify';
import { HOST_API_URL } from '../../../config-global';

CustomToolbar.propTypes = {
   setOpenNewOrder: PropTypes.func,
   viewAllItems: PropTypes.bool,
   setViewAllItems: PropTypes.func
};

export default function CustomToolbar({setOpenNewOrder, viewAllItems, setViewAllItems}) {
    
    const location = useLocation();
    const orderStatus = location.pathname.split('/').pop().replace('-rentals', '').toLowerCase();
   
    const downloadOrders = () => {
      window.open(`${HOST_API_URL}Api/Rental/DownloadRentals?orderStatus=${orderStatus}`, '_blank');
    };
    const downloadItems = () => {
      window.open(`${HOST_API_URL}Api/Rental/DownloadRentalItems?orderStatus=${orderStatus}`, '_blank');
    }


return (
    <>
      <Stack direction = {'row'}>
        {orderStatus === 'current' && 
           <ScopeGuard scopes={['Rental-Order-Approve']} allowAdmin>
              <Tooltip title="Add an existing order to this table">
                <Button color="secondary" onClick={() => setOpenNewOrder(true)} sx = {{marginLeft: "10px"}} variant="outlined" size="small" startIcon={<Iconify icon={"eva:plus-outline"} />} >
                    Add Existing Rental
                </Button>
              </Tooltip>
            </ScopeGuard>}
            <Button
              color="secondary"
              variant="outlined"
              size="small"
              onClick={viewAllItems ? downloadItems : downloadOrders}
              startIcon={<Iconify icon="file-icons:microsoft-excel" />}
              sx = {{marginLeft: "10px"}}
            > 
              Download Rental {viewAllItems ? "Items" : "Orders"}
            </Button>
            <Button
              color="secondary"
              variant="outlined"
              size="small"
              onClick={() => setViewAllItems(!viewAllItems)}
              startIcon={<Iconify icon="healthicons:magnifying-glass" />}
              sx = {{marginLeft: "10px"}}
            > 
              {viewAllItems ? "View Rentals" :  "View All Rental Items" }
            </Button>
        </Stack>
      </>
  );
}